import { render, staticRenderFns } from "./lafia_castle.vue?vue&type=template&id=e1e7c7e4"
import script from "./lafia_castle.vue?vue&type=script&lang=js"
export * from "./lafia_castle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports